import { render, staticRenderFns } from "./single-package-input-field.vue?vue&type=template&id=28d35eda&"
import script from "./single-package-input-field.vue?vue&type=script&lang=js&"
export * from "./single-package-input-field.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports